import { useLocation, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Home } from "lucide-react";
import { Seo } from "@/components/Seo";

const NotFound = () => {
  const location = useLocation();

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-navy-deep via-navy-deep to-slate-900">
      <Seo title="Page Not Found | Yaw CTV" noindex />
      <div className="text-center px-4">
        <h1 className="mb-4 text-6xl font-bold text-white">404</h1>
        <p className="mb-6 text-xl text-white/60">
          The page you're looking for doesn't exist.
        </p>
        <Button asChild className="bg-gold hover:bg-gold-light text-dark-bg font-semibold">
          <Link to="/">
            <Home className="w-4 h-4 mr-2" />
            Return Home
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
